<script>
export default {
  methods: {
    quotationClick
  }
}
function quotationClick() {
  this.$emit('click-quotation')
}
</script>
<template>
  <div>
    <div @click="quotationClick" class="quotation_button default_button">
      <slot />
    </div>
  </div>
</template>
<style lang="scss">
.quotation_button {
  height: 46px;
  font-weight: bold;
}
</style>
